import React, { Fragment, useEffect, } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { toast } from 'react-toastify';
import { sortBy, groupBy, pickBy, get } from 'lodash';
import { useToggle } from 'react-use';
import numeral from 'numeral';
import jsbarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';

import firebase, { functions } from '../../firebase';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import { printerFields as printersSettingFields } from '../../shared/models/setting';
import { fields as printerFields } from '../../shared/models/printer';

const { entries, keys } = Object;
const db = firebase.firestore();
const settingsRef = db.collection('settings');
const printersRef = db.collection('printers');

export default AdminPage(function AdminPrinters (props) {
  const { user } = props;
  const printersSetting = useDocumentSubscription(settingsRef.doc('printers'));
  const printers = useCollectionSubscription(printersRef.orderBy('createdAt'));
  useEffect(() => {
    if(printersSetting === null) {
      settingsRef.doc('printers').set({ createdAt: new Date() }, { merge: true });
    }
  }, [printersSetting]);

  return printersSetting != null && (
    <div className="admin-locations container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>プリンター管理</h4>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <EditButton itemRef={printersSetting.ref} FormModal={ModelFormModal} formProps={{ title: '各種プリンターID設定', fields: printersSettingFields, }} />
        </div>
        <div>
          <table className="table">
            <thead className="thead-light text-center">
              <tr>
                <th>種別</th>
                <th>プリンターID</th>
              </tr>
            </thead>
            <tbody>
              {
                entries(printersSettingFields()).map(([key, { label }]) => {
                  return (
                    <tr key={key}>
                      <td>
                        {label}
                      </td>
                      <td>
                        {get(printersSetting, key)}
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <hr className="my-5" />
        <div>
          <h5>プリンター</h5>
          <div className="d-flex justify-content-end mb-3">
            <AddButton itemRef={printersRef.doc()} FormModal={ModelFormModal} formProps={{ title: 'プリンター 追加', fields: printerFields, }} />
          </div>
          <table className="table">
            <thead className="thead-light text-center">
              <tr>
                <th>名称</th>
                <th>PrintNode プリンターID</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                printers.map((printer) => {
                  const { id, ref, name, printnodePrinterId } = printer;
                  return (
                    <tr key={id}>
                      <td>{name}</td>
                      <td>{printnodePrinterId}</td>
                      <td className="text-right text-nowrap">
                        <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'プリンター 編集', fields: printerFields, }} />
                        <DeleteButton item={printer} itemRef={ref} className="ml-2" />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});
